import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import 'firebase/messaging'
import axios from 'axios'

import store from '@/store'
import eventModule from '@/store/event'
import { Card, CardList } from '@/types/Card'

const name = 'home'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class HomeModule extends VuexModule {
  private featuredList: Card[] = []
  private featuredData: Pick<CardList, 'interval'> = { interval: null }
  private cardLists: CardList[] = []
  private currentCardList: CardList | null = null
  private currentCard: Card | null = null
  private cardId: string | null = null
  private loading = false

  get featured(): Card[] {
    return this.featuredList
  }

  get featuredCardList(): Pick<CardList, 'interval'> {
    return this.featuredData
  }

  get cardlists(): CardList[] {
    return this.cardLists
  }

  get cardlist(): CardList | null {
    return this.currentCardList
  }

  get card(): Card | null {
    return this.currentCard
  }

  get isLoading(): boolean {
    return this.loading
  }

  @Mutation
  private setFeaturedCardList(payload: Pick<CardList, 'interval'>) {
    this.featuredData = payload
  }

  @Mutation
  private setfeaturedList(payload: Card[]) {
    this.featuredList = payload
  }

  @Mutation
  private setCardLists(payload: CardList[]) {
    this.cardLists = payload
  }

  @Mutation
  private setCurrentCardList(payload: CardList) {
    this.currentCardList = payload
  }

  @Mutation
  private setCurrentCard(payload: Card) {
    this.currentCard = payload
  }

  @Mutation
  private setCardId(payload: string | null) {
    this.cardId = payload
  }

  @Mutation
  private setLoading(payload: boolean) {
    this.loading = payload
  }

  @Action({ rawError: true })
  async fetchCardlist(cardListId: string) {
    try {
      const { data } = await axios.get(`deals/home/cards/lists/${cardListId}`)
      this.setCardList(data.cardList)
    } catch (error) {
      eventModule.newError('Karten-Listen konnte nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async fetchAll() {
    try {
      const { data } = await axios.get('deals/home')
      this.context.commit('setfeaturedList', data.featured)
      this.context.commit('setFeaturedCardList', data.featuredData)
      this.context.commit('setCardLists', data.cardLists)
    } catch (error) {
      eventModule.newError('Home Feed konnte nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  setCardList(payload: CardList) {
    this.context.commit('setCurrentCardList', payload)
  }

  @Action({ rawError: true })
  setCard(payload: Card) {
    this.context.commit('setCurrentCard', payload)
  }

  @Action({ rawError: true })
  async setCardById(id: string) {
    if (this.cardId === id) return
    this.context.commit('setCardId', id)
    this.context.commit('setLoading', true)
    try {
      const { data } = await axios.get(`deals/card/${id}`)
      const payload: Card | undefined = data.card
      if (payload) {
        this.context.commit('setCurrentCard', payload)
        return
      }
    } catch (err) {
      console.error('error fetching card', err)
    } finally {
      this.context.commit('setLoading', false)
    }
  }
}

export default getModule(HomeModule)
